import {I18n} from '@aws-amplify/core';
import {Stack} from '@mantine/core';
import {
    PlatformPropertyCard,
    PlatformPropertyCardEntryInput
} from '@flexinet/ui-components';

import {ProviderMapping} from '../types';
import {SyncStatusBadge} from './SyncStatusBadge';
import {EntityTypeBadge} from './EntityTypeBadge';

// Typed, not cast (§13): a cast switches off the excess-property check that catches a
// misspelt key. Empty optional fields render the dash rather than a blank row.
export const ProviderMappingPropertyCard = ({record}: { record: ProviderMapping }) => {

    const mapping: PlatformPropertyCardEntryInput[] = [
        {
            label: I18n.get('Entity Type'),
            value: <EntityTypeBadge entityType={record.entityType}/>,
            span: 6,
        }, {
            label: I18n.get('Local Entity ID'),
            value: record.localEntityId,
            formatter: 'code',
            span: 6,
        }, {
            label: I18n.get('Billing Provider'),
            value: record.billingProvider?.name ?? record.billingProviderId,
            span: 6,
        }, {
            label: I18n.get('Provider Entity ID'),
            value: record.providerEntityId,
            formatter: 'code',
            emptyAs: 'dash',
            span: 6,
        },
    ];

    const sync: PlatformPropertyCardEntryInput[] = [
        {
            label: I18n.get('Sync Status'),
            value: <SyncStatusBadge status={record.syncStatus}/>,
            span: 6,
        }, {
            label: I18n.get('Last Sync'),
            value: record.lastSyncAt,
            formatter: 'timestamp',
            emptyAs: 'dash',
            span: 6,
        }, {
            label: I18n.get('Sync Error'),
            value: record.syncError,
            emptyAs: 'dash',
            span: 12,
        },
    ];

    const audit: PlatformPropertyCardEntryInput[] = [
        {
            label: I18n.get('Created'),
            value: record.created,
            formatter: 'timestamp',
            emptyAs: 'dash',
            span: 6,
        }, {
            label: I18n.get('Updated'),
            value: record.updated,
            formatter: 'timestamp',
            emptyAs: 'dash',
            span: 6,
        }, {
            label: I18n.get('Created By'),
            value: record.createdByUser ?? (record.createdByUsername ? {name: record.createdByUsername} : null),
            formatter: 'person',
            emptyAs: 'dash',
            span: 6,
        }, {
            label: I18n.get('Mapping ID'),
            value: record.id,
            formatter: 'code',
            span: 6,
        },
    ];

    return (
        <Stack gap='xl'>
            <PlatformPropertyCard properties={mapping}/>
            <PlatformPropertyCard properties={sync}/>
            <PlatformPropertyCard properties={audit}/>
        </Stack>
    );
};
